import { AxiosInstance, AxiosResponse } from 'axios';
import { TCountry, TLocaleAPI } from '../types/locale';

export type TCountryEndpoints = {
    getCountryData: (countryCode: string) => Promise<AxiosResponse<TCountry>>;
};

// #TODO: Delete this comment. @Tharaka/@Charitha:
// it's important to type the api.get<> so that Axios knows what the type the call returns.
// https://levelup.gitconnected.com/a-typescript-safe-api-82cc22c4f92d

// #TODO: Type "object"
export default (api: AxiosInstance, apiLocale: TLocaleAPI): TCountryEndpoints => {
    const getCountryData = async (countryCode: string): Promise<AxiosResponse<TCountry>> =>
        api.get<TCountry>(`/_svc/misc/v2/country/${countryCode}`, { headers: { 'x-locale': apiLocale } });

    return { getCountryData };
};
